import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { transitions, breakpoints, functions, palette, shape } = theme;
  const { miniSidenav } = ownerState;

  const sidebarWidth = 260;
  const { pxToRem } = functions;
  const margin = pxToRem(16);

  // This style creates the "floating" and "bordered" effect.
  const borderedContainerStyles = {
    margin,
    borderRadius: shape.borderRadius,
    border: `1px solid ${palette.divider}`,
    height: `calc(100vh - ${margin} * 2)`, // Adjust height to account for vertical margins
    boxShadow: "0rem 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.05), 0rem 0.125rem 0.25rem -0.0625rem rgba(0, 0, 0, 0.03)",
    backgroundColor: palette.background.paper,
    backgroundImage: "none", // Ensure no gradients are applied
  };

  const drawerOpenStyles = () => ({
    ...borderedContainerStyles,
    transform: "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),
    [breakpoints.up("xl")]: {
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create("width", {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  const drawerCloseStyles = () => ({
    ...borderedContainerStyles,
    transform: `translateX(calc(-100% - ${margin}))`, // Ensure it hides completely off-screen
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),
    [breakpoints.up("xl")]: {
      width: pxToRem(96),
      overflowX: "hidden",
      transform: "translateX(0)",
      transition: transitions.create("width", {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  });

  return {
    "& .MuiDrawer-paper": {
      // We make the drawer container itself transparent to see our styled paper
      backgroundColor: "transparent", 
      border: "none",
      boxShadow: "none",
      // Apply the open or close styles which contain the bordered look
      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },

    // 🌟 Foreground color styles for the light theme
    "& .MuiListItemIcon-root": {
      color: palette.text.secondary, // A softer grey for icons
      transition: "color 0.2s ease-in-out",
    },
    "& .MuiListItemText-primary": {
      color: palette.text.primary, // The primary dark text color
      fontWeight: 400,
    },
    "& .MuiListItem-root": {
      position: "relative",
    },
    "& .MuiListItem-root:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)", // Standard light theme hover
    },
    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: "rgba(25, 118, 210, 0.08)", // A light blue tint

      "& .MuiListItemIcon-root": {
        color: palette.primary.main, // Primary blue for the icon
      },
      "& .MuiListItemText-primary": {
        color: palette.primary.main, // Primary blue for the text
        fontWeight: 600,
      },
       // ✅ A clean, sharp indicator bar for the selected item
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: "15%",
        height: "70%",
        width: "3px",
        borderRadius: "2px",
        backgroundColor: palette.primary.main,
      },
    },
  };
});